import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProfileService } from '../services/profile.service';

export const profileGuard: CanActivateFn = (route, state) => {
  const service = inject(ProfileService)
  const router = inject(Router)
  // console.log('profileGuard');
  // console.log('Ruta Activa', route);
  // console.log('Ruta Desactivada', state.url);
  if (service.profile()?.user_type?.access) {
    return true;
  }
  const profile = service.profile()
  // Validar si el usuario está logueado
  if (profile) {
    // console.log('Perfil valido');
    return true;
  } else {
    // console.log('Perfil no valido');
    return router.createUrlTree(['/profile/login'])
  }
};

